import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart, X } from 'lucide-react';
const names = ['María', 'Juan', 'Carolina', 'Martín', 'Lucía', 'Federico', 'Valentina', 'Alejandro', 'Camila', 'Santiago', 'Paula', 'Nicolás', 'Florencia', 'Andrés', 'Daniela', 'Matías', 'Agustina', 'Tomás', 'Rocío', 'Emilio'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'Corrientes', 'San Luis', 'Paraná', 'Formosa', 'Catamarca', 'Río Gallegos'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentPurchase({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      triggerPopup();
      // Then trigger randomly between 8-12 seconds
      const interval = setInterval(() => {
        triggerPopup();
      }, Math.floor(Math.random() * 4000) + 8000); // 8000 to 12000 ms
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-175">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-6 left-6 z-50 max-w-sm bg-navy-light border border-gold/30 rounded-lg shadow-2xl p-4 flex items-start gap-4" data-id="element-176">
          <div className="bg-gold/20 p-2 rounded-full shrink-0" data-id="element-177">
            <ShoppingCart className="w-5 h-5 text-gold" data-id="element-178" />
          </div>
          <div className="flex-grow pr-4" data-id="element-179">
            <p className="text-sm text-gray-200 leading-tight" data-id="element-180">
              <span className="font-bold text-white" data-id="element-181">
                {currentPurchase.name}
              </span>{' '}
              de{' '}
              <span className="font-bold text-white" data-id="element-182">
                {currentPurchase.city}
              </span>{' '}
              acaba de comprar el Sistema PRO
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-183">Hace unos instantes</p>
          </div>
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors" data-id="element-184">
            <X className="w-4 h-4" data-id="element-185" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}